export default __webpack_public_path__ + "static/media/search-gray.f54200b4.svg";